import e from "./index13.js";
import t from "./index27.js";
import { createUnarySpacing as n } from "./index37.js";
import r from "./index38.js";
import i from "./index44.js";
import a from "./index45.js";
import { hslToRgb as o, private_safeAlpha as s, private_safeColorChannel as c, private_safeDarken as l, private_safeEmphasize as u, private_safeLighten as d } from "./index67.js";
import f from "./index73.js";
import p from "./index75.js";
import { createGetColorSchemeSelector as m } from "./index76.js";
import h from "./index90.js";
import { stringifyTheme as g } from "./index96.js";
import _ from "./index97.js";
import v, { getOpacity as y, getOverlays as b } from "./index99.js";
import x from "./index100.js";
import S from "./index102.js";
//#region ../../node_modules/.pnpm/@mui+material@7.1.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+_8c76256369110b2505f132f86162c9a6/node_modules/@mui/material/esm/styles/createThemeWithVars.js
function C(e, t) {
	t.forEach((t) => {
		e[t] || (e[t] = {});
	});
}
function w(e, t, n) {
	!e[t] && n && (e[t] = n);
}
function T(e) {
	return typeof e != "string" || !e.startsWith("hsl") ? e : o(e);
}
function E(e, t) {
	`${t}Channel` in e || (e[`${t}Channel`] = c(T(e[t]), `MUI: Can't create \`palette.${t}Channel\` because \`palette.${t}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().
To suppress this warning, you need to explicitly provide the \`palette.${t}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`));
}
function D(e) {
	return typeof e == "number" ? `${e}px` : typeof e == "string" || typeof e == "function" || Array.isArray(e) ? e : "8px";
}
var O = (e) => {
	try {
		return e();
	} catch {}
}, k = (e = "mui") => f(e);
function A(e, t, n, r) {
	if (!t) return;
	t = t === !0 ? {} : t;
	let i = r === "dark" ? "dark" : "light";
	if (!n) {
		e[r] = v({
			...t,
			palette: {
				mode: i,
				...t?.palette
			}
		});
		return;
	}
	let { palette: a, ...o } = _({
		...n,
		palette: {
			mode: i,
			...t?.palette
		}
	});
	return e[r] = {
		...t,
		palette: a,
		opacity: {
			...y(i),
			...t?.opacity
		},
		overlays: t?.overlays || b(i)
	}, o;
}
function j(o = {}, ...f) {
	let { colorSchemes: _ = { light: !0 }, defaultColorScheme: v, disableCssColorScheme: y = !1, cssVarPrefix: b = "mui", shouldSkipGeneratingVar: j = x, colorSchemeSelector: M = _.light && _.dark ? "media" : void 0, rootSelector: N = ":root", ...P } = o, F = Object.keys(_)[0], I = v || (_.light && F !== "light" ? "light" : F), L = k(b), { [I]: R, light: z, dark: B, ...V } = _, H = { ...V }, U = R;
	if ((I === "dark" && !("dark" in _) || I === "light" && !("light" in _)) && (U = !0), !U) throw Error(process.env.NODE_ENV === "production" ? e(21, I) : `MUI: The \`colorSchemes.${I}\` option is either missing or invalid.`);
	let W = A(H, U, P, I);
	z && !H.light && A(H, z, void 0, "light"), B && !H.dark && A(H, B, void 0, "dark");
	let G = {
		defaultColorScheme: I,
		...W,
		cssVarPrefix: b,
		colorSchemeSelector: M,
		rootSelector: N,
		getCssVar: L,
		colorSchemes: H,
		font: {
			...h(W.typography),
			...W.font
		},
		spacing: D(P.spacing)
	};
	Object.keys(G.colorSchemes).forEach((e) => {
		let t = G.colorSchemes[e].palette, n = (e) => {
			let n = e.split("-"), r = n[1], i = n[2];
			return L(e, t[r][i]);
		};
		if (t.mode === "light" && (w(t.common, "background", "#fff"), w(t.common, "onBackground", "#000")), t.mode === "dark" && (w(t.common, "background", "#000"), w(t.common, "onBackground", "#fff")), C(t, [
			"Alert",
			"AppBar",
			"Avatar",
			"Button",
			"Chip",
			"FilledInput",
			"LinearProgress",
			"Skeleton",
			"Slider",
			"SnackbarContent",
			"SpeedDialAction",
			"StepConnector",
			"StepContent",
			"Switch",
			"TableCell",
			"Tooltip"
		]), t.mode === "light") {
			w(t.Alert, "errorColor", l(t.error.light, .6)), w(t.Alert, "infoColor", l(t.info.light, .6)), w(t.Alert, "successColor", l(t.success.light, .6)), w(t.Alert, "warningColor", l(t.warning.light, .6)), w(t.Alert, "errorFilledBg", n("palette-error-main")), w(t.Alert, "infoFilledBg", n("palette-info-main")), w(t.Alert, "successFilledBg", n("palette-success-main")), w(t.Alert, "warningFilledBg", n("palette-warning-main")), w(t.Alert, "errorFilledColor", O(() => t.getContrastText(t.error.main))), w(t.Alert, "infoFilledColor", O(() => t.getContrastText(t.info.main))), w(t.Alert, "successFilledColor", O(() => t.getContrastText(t.success.main))), w(t.Alert, "warningFilledColor", O(() => t.getContrastText(t.warning.main))), w(t.Alert, "errorStandardBg", d(t.error.light, .9)), w(t.Alert, "infoStandardBg", d(t.info.light, .9)), w(t.Alert, "successStandardBg", d(t.success.light, .9)), w(t.Alert, "warningStandardBg", d(t.warning.light, .9)), w(t.Alert, "errorIconColor", n("palette-error-main")), w(t.Alert, "infoIconColor", n("palette-info-main")), w(t.Alert, "successIconColor", n("palette-success-main")), w(t.Alert, "warningIconColor", n("palette-warning-main")), w(t.AppBar, "defaultBg", n("palette-grey-100")), w(t.Avatar, "defaultBg", n("palette-grey-400")), w(t.Button, "inheritContainedBg", n("palette-grey-300")), w(t.Button, "inheritContainedHoverBg", n("palette-grey-A100")), w(t.Chip, "defaultBorder", n("palette-grey-400")), w(t.Chip, "defaultAvatarColor", n("palette-grey-700")), w(t.Chip, "defaultIconColor", n("palette-grey-700")), w(t.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), w(t.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), w(t.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), w(t.LinearProgress, "primaryBg", d(t.primary.main, .62)), w(t.LinearProgress, "secondaryBg", d(t.secondary.main, .62)), w(t.LinearProgress, "errorBg", d(t.error.main, .62)), w(t.LinearProgress, "infoBg", d(t.info.main, .62)), w(t.LinearProgress, "successBg", d(t.success.main, .62)), w(t.LinearProgress, "warningBg", d(t.warning.main, .62)), w(t.Skeleton, "bg", `rgba(${n("palette-text-primaryChannel")} / 0.11)`), w(t.Slider, "primaryTrack", d(t.primary.main, .62)), w(t.Slider, "secondaryTrack", d(t.secondary.main, .62)), w(t.Slider, "errorTrack", d(t.error.main, .62)), w(t.Slider, "infoTrack", d(t.info.main, .62)), w(t.Slider, "successTrack", d(t.success.main, .62)), w(t.Slider, "warningTrack", d(t.warning.main, .62));
			let e = u(t.background.default, .8);
			w(t.SnackbarContent, "bg", e), w(t.SnackbarContent, "color", O(() => t.getContrastText(e))), w(t.SpeedDialAction, "fabHoverBg", u(t.background.paper, .15)), w(t.StepConnector, "border", n("palette-grey-400")), w(t.StepContent, "border", n("palette-grey-400")), w(t.Switch, "defaultColor", n("palette-common-white")), w(t.Switch, "defaultDisabledColor", n("palette-grey-100")), w(t.Switch, "primaryDisabledColor", d(t.primary.main, .62)), w(t.Switch, "secondaryDisabledColor", d(t.secondary.main, .62)), w(t.Switch, "errorDisabledColor", d(t.error.main, .62)), w(t.Switch, "infoDisabledColor", d(t.info.main, .62)), w(t.Switch, "successDisabledColor", d(t.success.main, .62)), w(t.Switch, "warningDisabledColor", d(t.warning.main, .62)), w(t.TableCell, "border", d(s(t.divider, 1), .88)), w(t.Tooltip, "bg", s(t.grey[700], .92));
		}
		if (t.mode === "dark") {
			w(t.Alert, "errorColor", d(t.error.light, .6)), w(t.Alert, "infoColor", d(t.info.light, .6)), w(t.Alert, "successColor", d(t.success.light, .6)), w(t.Alert, "warningColor", d(t.warning.light, .6)), w(t.Alert, "errorFilledBg", n("palette-error-dark")), w(t.Alert, "infoFilledBg", n("palette-info-dark")), w(t.Alert, "successFilledBg", n("palette-success-dark")), w(t.Alert, "warningFilledBg", n("palette-warning-dark")), w(t.Alert, "errorFilledColor", O(() => t.getContrastText(t.error.dark))), w(t.Alert, "infoFilledColor", O(() => t.getContrastText(t.info.dark))), w(t.Alert, "successFilledColor", O(() => t.getContrastText(t.success.dark))), w(t.Alert, "warningFilledColor", O(() => t.getContrastText(t.warning.dark))), w(t.Alert, "errorStandardBg", l(t.error.light, .9)), w(t.Alert, "infoStandardBg", l(t.info.light, .9)), w(t.Alert, "successStandardBg", l(t.success.light, .9)), w(t.Alert, "warningStandardBg", l(t.warning.light, .9)), w(t.Alert, "errorIconColor", n("palette-error-main")), w(t.Alert, "infoIconColor", n("palette-info-main")), w(t.Alert, "successIconColor", n("palette-success-main")), w(t.Alert, "warningIconColor", n("palette-warning-main")), w(t.AppBar, "defaultBg", n("palette-grey-900")), w(t.AppBar, "darkBg", n("palette-background-paper")), w(t.AppBar, "darkColor", n("palette-text-primary")), w(t.Avatar, "defaultBg", n("palette-grey-600")), w(t.Button, "inheritContainedBg", n("palette-grey-800")), w(t.Button, "inheritContainedHoverBg", n("palette-grey-700")), w(t.Chip, "defaultBorder", n("palette-grey-700")), w(t.Chip, "defaultAvatarColor", n("palette-grey-300")), w(t.Chip, "defaultIconColor", n("palette-grey-300")), w(t.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), w(t.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), w(t.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), w(t.LinearProgress, "primaryBg", l(t.primary.main, .5)), w(t.LinearProgress, "secondaryBg", l(t.secondary.main, .5)), w(t.LinearProgress, "errorBg", l(t.error.main, .5)), w(t.LinearProgress, "infoBg", l(t.info.main, .5)), w(t.LinearProgress, "successBg", l(t.success.main, .5)), w(t.LinearProgress, "warningBg", l(t.warning.main, .5)), w(t.Skeleton, "bg", `rgba(${n("palette-text-primaryChannel")} / 0.13)`), w(t.Slider, "primaryTrack", l(t.primary.main, .5)), w(t.Slider, "secondaryTrack", l(t.secondary.main, .5)), w(t.Slider, "errorTrack", l(t.error.main, .5)), w(t.Slider, "infoTrack", l(t.info.main, .5)), w(t.Slider, "successTrack", l(t.success.main, .5)), w(t.Slider, "warningTrack", l(t.warning.main, .5));
			let e = u(t.background.default, .98);
			w(t.SnackbarContent, "bg", e), w(t.SnackbarContent, "color", O(() => t.getContrastText(e))), w(t.SpeedDialAction, "fabHoverBg", u(t.background.paper, .15)), w(t.StepConnector, "border", n("palette-grey-600")), w(t.StepContent, "border", n("palette-grey-600")), w(t.Switch, "defaultColor", n("palette-grey-300")), w(t.Switch, "defaultDisabledColor", n("palette-grey-600")), w(t.Switch, "primaryDisabledColor", l(t.primary.main, .55)), w(t.Switch, "secondaryDisabledColor", l(t.secondary.main, .55)), w(t.Switch, "errorDisabledColor", l(t.error.main, .55)), w(t.Switch, "infoDisabledColor", l(t.info.main, .55)), w(t.Switch, "successDisabledColor", l(t.success.main, .55)), w(t.Switch, "warningDisabledColor", l(t.warning.main, .55)), w(t.TableCell, "border", l(s(t.divider, 1), .68)), w(t.Tooltip, "bg", s(t.grey[700], .92));
		}
		E(t.background, "default"), E(t.background, "paper"), E(t.common, "background"), E(t.common, "onBackground"), E(t, "divider"), Object.keys(t).forEach((e) => {
			let n = t[e];
			e !== "tonalOffset" && n && typeof n == "object" && (n.main && w(t[e], "mainChannel", c(T(n.main))), n.light && w(t[e], "lightChannel", c(T(n.light))), n.dark && w(t[e], "darkChannel", c(T(n.dark))), n.contrastText && w(t[e], "contrastTextChannel", c(T(n.contrastText))), e === "text" && (E(t[e], "primary"), E(t[e], "secondary")), e === "action" && (n.active && E(t[e], "active"), n.selected && E(t[e], "selected")));
		});
	}), G = f.reduce((e, n) => t(e, n), G);
	let K = {
		prefix: b,
		disableCssColorScheme: y,
		shouldSkipGeneratingVar: j,
		getSelector: S(G)
	}, { vars: q, generateThemeVars: J, generateStyleSheets: Y } = p(G, K);
	return G.vars = q, Object.entries(G.colorSchemes[G.defaultColorScheme]).forEach(([e, t]) => {
		G[e] = t;
	}), G.generateThemeVars = J, G.generateStyleSheets = Y, G.generateSpacing = function() {
		return r(P.spacing, n(this));
	}, G.getColorSchemeSelector = m(M), G.spacing = G.generateSpacing(), G.shouldSkipGeneratingVar = j, G.unstable_sxConfig = {
		...i,
		...P?.unstable_sxConfig
	}, G.unstable_sx = function(e) {
		return a({
			sx: e,
			theme: this
		});
	}, G.toRuntimeSource = g, G;
}
//#endregion
export { j as default };

//# sourceMappingURL=index103.js.map